import CryptoJS from "crypto-js";

const CALLBACK_HASH_SECRET_KEY = process.env.REACT_APP_SECRET_KEY; // Get key from .env

export function createNewHmac(inputData = {}) {
  if (!CALLBACK_HASH_SECRET_KEY) {
    throw new Error("HMAC Secret Key is missing in environment variables.");
  }

  // Original object mutate nahi hoga
  const data = { ...inputData };

  // HMAC related fields remove
  delete data.hmac;
  delete data.userHmac;
  delete data.mac;

  if ("actions" in data && Array.isArray(data.actions)) {
    const actionss = data.actions
      .map((action) =>
        Object.keys(action)
          .sort()
          .map((key) => String(action[key] ?? ""))
          .join(""),
      )
      .join("");

    data.actions = actionss;
  }

  const hmacBase = Object.keys(data)
    .sort()
    .map((key) => String(data[key] ?? ""))
    .join("");

  const hashResp = CryptoJS.SHA256(CALLBACK_HASH_SECRET_KEY.trim());

  const hmacResp = CryptoJS.HmacSHA256(hmacBase, hashResp);

  return CryptoJS.enc.Hex.stringify(hmacResp);
}

export function verifyHmac(payload) {
  if (!CALLBACK_HASH_SECRET_KEY) {
    throw new Error("HMAC Secret Key is missing in environment variables.");
  }

  const base = { ...payload };
  delete base.hmac;

  if ("actions" in base) {
    let actions = "";
    for (const action of base.actions) {
      Object.keys(action)
        .sort()
        .forEach((key) => (actions += action[key]));
    }
    base.actions = actions;
  }

  const hash = CryptoJS.SHA256(CALLBACK_HASH_SECRET_KEY);
  const hmac = CryptoJS.HmacSHA256("", hash);

  let hmacBase = "";
  Object.keys(base)
    .sort()
    .forEach((key) => (hmacBase += base[key]));

  const hmacString = CryptoJS.HmacSHA256(hmacBase, hmac).toString(
    CryptoJS.enc.Hex,
  );

  return hmacString === payload.hmac;
}


// for backend update 

// const hmacMiddleware = (req, res, next) => {
//   try {
//     const apiUrl = req.path;
//     const originalUrl = req.originalUrl;
//     const method = req.method;

//     const requestInfo = {
//       method,
//       path: apiUrl,
//       originalUrl,
//       ip: req.headers["x-forwarded-for"] || req.ip,
//       userAgent: req.headers["user-agent"],
//       bodyKeys: Object.keys(req.body || {}),
//       hasAuthorization: !!req.headers["authorization"],
//       hasHeaderHmac: !!req.headers["userhmac"],
//       hasBodyHmac: !!req.body?.userHmac,
//     };

//     const skipHmacRoutes = [
//     //   "/user/edit",
//     "/updateToken",
//     ];

//     const skipHmacPrefixes = [
//       "/updateToken/"
//     ];

//     const loginRoutes = ["/login", "/login/admin"];

//     const shouldSkipHmac =
//       skipHmacRoutes.includes(apiUrl) ||
//       skipHmacPrefixes.some((route) => apiUrl.startsWith(route));

//     // Jis route me HMAC nahi chahiye, usko yaha log karke pass kar do
//     if (shouldSkipHmac) {
//       console.log("HMAC SKIPPED API =>", {
//         ...requestInfo,
//         reason: "Route is whitelisted for HMAC skip",
//       });

//       return next();
//     }

//     let payload;
//     let userHmac;

//     const currentToken = req.headers["authorization"]
//       ? req.headers["authorization"].trim()
//       : "";

//     if (req.headers["userhmac"]) {
//       payload = { token: currentToken };
//       userHmac = req.headers["userhmac"];

//       console.log("HMAC SOURCE => HEADER", {
//         ...requestInfo,
//         payloadKeys: Object.keys(payload),
//       });
//     } else {
//       payload = req.body || {};
//       userHmac = req.body?.userHmac;

//       console.log("HMAC SOURCE => BODY", {
//         ...requestInfo,
//         payloadKeys: Object.keys(payload),
//       });
//     }

//     // Login routes
//     if (loginRoutes.includes(apiUrl)) {
//       console.log("LOGIN HMAC CHECK START =>", requestInfo);

//       if (!userHmac) {
//         console.warn("LOGIN HMAC MISSING =>", requestInfo);

//         return res.status(401).send({
//           status: false,
//           msg: "Invalid Request. Please reinstall your app",
//         });
//       }

//       const isHMACValid = verifyHmac(payload, userHmac);

//       if (!isHMACValid) {
//         console.warn("LOGIN HMAC INVALID =>", {
//           ...requestInfo,
//           receivedHmac: userHmac,
//         });

//         return res.status(401).send({
//           status: false,
//           msg: "Invalid Request. Please reinstall your app",
//         });
//       }

//       console.log("LOGIN HMAC VALID =>", {
//         ...requestInfo,
//       });

//       if (!req.body.newTime) {
//         console.warn("LOGIN newTime MISSING =>", requestInfo);

//         return res.status(400).json({
//           error: "Invalid Request. Please uninstall and install again your app",
//         });
//       }

//       const requestTime = Math.floor(
//         new Date(req.body.newTime).getTime() / 1000,
//       );

//       if (isNaN(requestTime)) {
//         console.warn("LOGIN newTime INVALID =>", {
//           ...requestInfo,
//           newTime: req.body.newTime,
//         });

//         return res.status(400).json({
//           error: "Invalid Request. Please uninstall and install again your app",
//         });
//       }

//       const currentTime = Math.floor(Date.now() / 1000);
//       const diff = Math.abs(currentTime - requestTime);

//       const maxAllowedDifference = 5 * 60; // 5 minutes

//       console.log("LOGIN TIME DEBUG =>", {
//         path: apiUrl,
//         currentTime,
//         requestTime,
//         diff,
//         maxAllowedDifference,
//         newTime: req.body.newTime,
//       });

//       if (diff > maxAllowedDifference) {
//         console.warn("LOGIN REQUEST EXPIRED =>", {
//           ...requestInfo,
//           diff,
//           maxAllowedDifference,
//           newTime: req.body.newTime,
//         });

//         return res.status(401).json({
//           error: "Invalid Request.",
//           reason: "Request expired",
//         });
//       }

//       console.log("LOGIN REQUEST PASSED =>", {
//         method,
//         path: apiUrl,
//       });

//       return next();
//     }

//     // Baaki all APIs ke liye HMAC required
//     if (!userHmac) {
//       console.warn("HMAC MISSING API =>", {
//         ...requestInfo,
//         reason: "This API requires HMAC but userHmac was not found",
//       });

//       return res.status(401).send({
//         status: false,
//         msg: "HMAC missing in request",
//       });
//     }

//     const isHMACValid = verifyHmac(payload, userHmac);

//     if (!isHMACValid) {
//       console.warn("HMAC INVALID API =>", {
//         ...requestInfo,
//         receivedHmac: userHmac,
//       });

//       return res.status(401).send({
//         status: false,
//         msg: "Invalid Request. Please reinstall your app",
//       });
//     }

//     console.log("HMAC VALID API =>", {
//       method,
//       path: apiUrl,
//       originalUrl,
//       source: req.headers["userhmac"] ? "header" : "body",
//     });

//     return next();
//   } catch (e) {
//     console.error("HMAC VERIFICATION FAILED EXCEPTION =>", {
//       error: e.message,
//       stack: e.stack,
//       method: req.method,
//       path: req.path,
//       originalUrl: req.originalUrl,
//       bodyKeys: Object.keys(req.body || {}),
//     });

//     return res.status(401).send({
//       status: false,
//       msg: "Invalid Request. Please reinstall your app",
//     });
//   }
// };